// technician-renderer.component.ts
import { Component } from '@angular/core';
import { ICellRendererAngularComp, ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams, ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-technician-renderer',
  template: `
    <div *ngIf="!params">Loading...</div>
    <div *ngIf="params && isEditing" class="dropdown-container">
      <mat-select
        class="select"
        [(ngModel)]="selectedTechnicianId"
        (selectionChange)="onTechnicianChange()"
        placeholder="Select Technician"
      >
        <mat-option *ngFor="let tech of technicians" [value]="tech.id">
          {{ tech.name }}
        </mat-option>
      </mat-select>
    </div>
    <div *ngIf="params && !isEditing">
      {{ displayValue || 'No Technician' }}
    </div>
  `,
  styles: [`
    .dropdown-container {
      box-sizing: border-box;
      height: 49px;
      border: 1px solid #c8c9cc;
      border-radius: 4px;
      display: flex;
      align-items: center;
      /* margin: 0.5rem; */
    }
    .select {
      width: 100%;
      text-align: center;
      font-size: 14px;
    }
  `]
})
export class TechnicianRendererComponent implements ICellRendererAngularComp, ICellEditorAngularComp {
  params: any;
  isEditing: boolean = false;
  selectedTechnicianId: number | null = null;
  displayValue: string = '';
  technicians = [
    { id: 1, name: 'John Doe' },
    { id: 2, name: 'Jane Smith' },
    { id: 3, name: 'Mike Johnson' },
    { id: 4, name: 'Sarah Williams' }
  ];

  agInit(params: ICellRendererParams | ICellEditorParams): void {
    this.params = params;
    this.isEditing = !!(params as ICellEditorParams).colDef.cellEditor;
    this.setValues(params.value || this.technicians[0]); // Default to first technician
  }

  refresh(params: any): boolean {
    this.params = params;
    this.setValues(params.value || this.technicians[0]);
    return true;
  }

  getValue(): any {
    return this.technicians.find(tech => tech.id === this.selectedTechnicianId) || this.technicians[0];
  }

  private setValues(value: any): void {
    if (value && value.id && value.name) {
      this.selectedTechnicianId = value.id;
      this.displayValue = value.name;
    } else {
      this.selectedTechnicianId = this.technicians[0].id;
      this.displayValue = this.technicians[0].name;
    }
  }

  onTechnicianChange(): void {
    if (this.params && this.params.api) {
      const newValue = this.getValue();
      this.params.node.setDataValue(this.params.column.colId, newValue);
      this.displayValue = newValue.name;
    }
  }
}